import React from 'react';
import { painPoints } from '../../data/content';
import { TransformCTA } from '../TransformCTA';
export function PainPoints() {
  return <section className="w-full bg-navy px-4 py-14 sm:py-20" data-id="element-198" data-mp="1twgsyk0u7w5y">
      <div className="mx-auto max-w-3xl" data-id="element-199" data-mp="27mkch38c1brp">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-white/40" data-id="element-200" data-mp="27nlpvectmacl">
          Reconócelo
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] leading-tight font-black tracking-tight text-white sm:text-4xl" data-id="element-201" data-mp="2hki1vu1xhelw">
          ¿Te está pasando esto <span className="italic text-brandred-light" data-id="element-202" data-mp="2ckvljbqszi8v">ahora mismo</span>?
        </h2>

        <ul className="mt-9 space-y-3" data-id="element-203" data-mp="2qjvaylm54163">
          {painPoints.map(p => <li key={p.text} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.06] p-4" data-id="element-204" data-mp="2mjbe7j5hazkh">
              <span className="text-xl leading-none" aria-hidden data-id="element-205" data-mp="w8yohle7lg7r">
                {p.emoji}
              </span>
              <span className="text-[14px] leading-snug text-white/85 sm:text-[15px]" data-id="element-206" data-mp="1n7tokgbxnxgd">{p.text}</span>
            </li>)}
        </ul>

        <div className="mt-9 rounded-2xl border border-brandred/40 bg-brandred/10 p-5 text-center" data-id="element-207" data-mp="1s7ocqc4bq8xq">
          <p className="font-display text-xl font-black text-white sm:text-2xl" data-id="element-208" data-mp="1x57qlax40jp5">
            No necesitas más teoría
          </p>
          <p className="mt-1 text-[14px] text-white/70" data-id="element-209" data-mp="21yssvf5qjzu5">
            Necesitas un sistema que te guíe en el momento crítico.
          </p>
        </div>

        <TransformCTA text="Necesito un sistema que decida conmigo" variant="dark" data-id="element-210" data-mp="2awmik78zvv8c" />
      </div>
    </section>;
}